import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import {
  formatISO2DisplayDateString,
  formatISO2DisplayTimeString,
} from 'utils/dateFunctions';
import i18n from 'i18n';
import { toast } from 'react-toastify';

import './EHRTimelineCard.css';
import { useReportModalContext } from 'contexts/ReportModalContext';
import { ToastMessage } from 'components';

const typeDict = {
  'SumárioAlta.v4.0': 'Sumário de Alta',
  'RegistroAtendimentoClínico.v4.1': 'Registro de Atendimento Clínico',
  'RegistroAtendimentoClínico.v4.2': 'Registro de Atendimento Clínico',
};

export function EHRTimelineCard({
  date,
  type,
  practitioner,
  organizationName,
  documentBinaryId,
  alias,
}) {
  const { selectReport } = useReportModalContext();

  function handleClick() {
    try {
      selectReport({
        idArg: documentBinaryId,
        practitioner,
        isoDate: date,
        organization: alias,
      });
    } catch (err) {
      toast.error(
        <ToastMessage>Houve um problema ao carregar o documento</ToastMessage>,
      );
    }
  }

  return (
    <Paper
      elevation={3}
      className="ehrTimeline-card"
      onClick={handleClick}
      role="button"
    >
      <div className="ehrCard-header">
        <div style={{ display: 'flex' }}>
          <p className="ehrCard-date">
            {formatISO2DisplayDateString(date, i18n.language)}
          </p>
          <p className="ehrCard-time">
            {formatISO2DisplayTimeString(date, i18n.language).slice(0, -3)}
          </p>
        </div>
        <p className="ehrCard-organization">
          {alias.toUpperCase() || organizationName.toUpperCase()}
        </p>
      </div>
      <p className="ehrCard-docType">{typeDict[type]}</p>
      <p className="ehrCard-practitioner">{`Profissional: ${practitioner}`}</p>
    </Paper>
  );
}

EHRTimelineCard.propTypes = {
  date: PropTypes.string,
  type: PropTypes.string,
  practitioner: PropTypes.string,
  organizationName: PropTypes.string,
  alias: PropTypes.string,
  documentBinaryId: PropTypes.string.isRequired,
};

EHRTimelineCard.defaultProps = {
  date: 'Indisponível',
  type: 'Indisponível',
  practitioner: 'Indisponível',
  organizationName: 'Indisponível',
  alias: 'Indisponível',
};
